// extracted by mini-css-extract-plugin
export var errorsContainer = "_r6-1";
export var link = "_r6-0";